module.exports = __webpack_public_path__ + "media/images/ficha-2-c1973a9d687e13f8d40d75f08e734c0c.png";